/**
 * Phase 16 — shared support UI helpers (status pill tones, category labels, etc.)
 */
export const STATUS_LABELS = {
    open: "Open",
    awaiting_user: "Awaiting your reply",
    resolved: "Resolved",
    closed: "Closed",
};

export const STATUS_TONES = {
    open: "border-amber-200 bg-amber-50 text-amber-800",
    awaiting_user: "border-primary/40 bg-primary/10 text-primary",
    resolved: "border-emerald-200 bg-emerald-50 text-emerald-700",
    closed: "border-border bg-secondary text-muted-foreground",
};

export const CATEGORY_LABELS = {
    general: "General",
    billing: "Billing",
    bug: "Bug",
    feature_request: "Feature request",
    other: "Other",
};

export const PRIORITY_LABELS = {
    low: "Low",
    normal: "Normal",
    high: "High",
};

export const PRIORITY_TONES = {
    low: "border-border bg-secondary text-muted-foreground",
    normal: "border-border bg-secondary text-foreground",
    high: "border-rose-300 bg-rose-50 text-rose-700",
};

export const formatTicketNumber = (n) => `HL-${String(n).padStart(3, "0")}`;
